import Level1 from './scenes/Level1';
import Level2 from './scenes/Level2';
import Level3 from './scenes/Level3';
import Level4 from './scenes/Level4';
import Title from './scenes/Title';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [Title, Level1, Level2, Level3, Level4],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: Title.KEY,

  // startScene: Level1.KEY,
  // startScene: Level2.KEY,
  // startScene: Level3.KEY,
  // startScene: Level4.KEY,

  config: {
    gameOver: false,
    gamePaused: false,
    level: 1,

    /** @type {string[]} */
    levelWordBank: [],
    gameMode: 1,

    maxScore: 4
  }
};
